<template>
  <div>
    <v-card :class="topBorderClass" tile>
      <v-toolbar color="white" flat>
        <v-toolbar-title class="app-blue--text font-weight-light">
          {{ title }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- <v-btn
          text
          icon
          color="app-blue"
          class="mr-0"
          v-if="hasTasks"
          @click="showArchivedTasks()"
        >
          <v-icon>mdi-archive</v-icon>
        </v-btn> -->
        <v-btn
          v-if="canAddTasks"
          color="app-blue"
          text
          icon
          @click="open()"
          class="mr-0"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-toolbar>
      <div v-if="!hasTasks" class="text-center pb-2">
        <span class="text-subtitle-1 font-weight-light">
          {{ $t('missions.missionHasNoTasks') }}
        </span>
      </div>
      <div v-else class="py-2">
        <tasks-types-filter
          @onTasksFilterChange="onTasksFilterChange"
          filterName="missionTasksTypesFilter"
        ></tasks-types-filter>
      </div>
    </v-card>
    <div class="py-0" v-if="hasTasks">
      <div v-for="tasksList of tasksLists" :key="tasksList.name">
        <div v-if="filters[tasksList.name] || !hasSelectedFilters">
          <tasks-list
            :title="$t(tasksList.i18nKey)"
            :tasks="tasksList.tasks"
            :topBorderClass="tasksList.borderClass"
            :titleTextColorClass="tasksList.textClass"
          >
            <template #default="{ task }">
              <group-mission-task
                :isLeader="isLeader"
                :mission="mission"
                :task="task"
              ></group-mission-task>
            </template>
          </tasks-list>
        </div>
      </div>

      <div id="mission-archived-tasks">
        <tasks-list
          v-if="toggleArchivedTasks"
          topBorderClass="border-top-red"
          titleTextColorClass="app-red--text"
          :title="$t('tasks.archived')"
          :mission="mission"
          :tasks="archivedTasks"
          :closeTasksPanel="closeArchivedTasks"
        >
          <group-mission-task
            :isLeader="isLeader"
            :mission="mission"
            :task="task"
          ></group-mission-task>
        </tasks-list>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ManageGroupMissionTaskModal from './ManageGroupMissionTaskModal';
import TasksList from '../../../tasks/TasksList';
import GroupMissionTask from './GroupMissionTask';
import TasksTypesFilter from '../../../tasks/TasksTypesFilter';
import missionStatuses from '@/enums/mission.statuses';
import taskTypes from '@/enums/task.types';
import { UPDATE_MISSION_TASKS_TYPES_FILTER } from '../../../../store/missions/tasks/types';
import tasksListsService from '../../../../services/tasks.lists.service';

const ARCHIVED_TASKS_SELECTOR = '#mission-archived-tasks';

export default {
  name: 'group-mission-tasks',
  components: {
    TasksTypesFilter,
    TasksList,
    GroupMissionTask
  },
  props: {
    mission: {
      type: Object
    },
    topBorderClass: {
      type: String,
      default: 'border-top-blue'
    },
    title: String,
    isLeader: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      toggleArchivedTasks: false
    };
  },
  computed: {
    ...mapGetters(['missionTasksTypesFilter']),
    canAddTasks() {
      return (
        this.isLeader &&
        !this.$route.query.userId &&
        (this.mission.status === missionStatuses.active ||
          this.mission.status === missionStatuses.pending)
      );
    },
    hasTasks() {
      return this.mission.tasks.length > 0;
    },
    hasSelectedFilters() {
      return this.missionTasksTypesFilter.some(f => f.selected);
    },
    filters() {
      return this.missionTasksTypesFilter.reduce((acc, filter) => {
        acc[filter.type] = filter.selected;
        return acc;
      }, {});
    },
    todos() {
      return this.mission.tasks.filter(
        t => t.type === taskTypes.todo && !t.archived
      );
    },
    dailies() {
      return this.mission.tasks.filter(
        t => t.type === taskTypes.daily && !t.archived
      );
    },
    weeklies() {
      return this.mission.tasks.filter(
        t => t.type === taskTypes.weekly && !t.archived
      );
    },
    archivedTasks() {
      return this.mission.tasks.filter(t => t.archived);
    },
    tasksLists() {
      return tasksListsService.getTasksListsConfiguration(
        this.todos,
        this.dailies,
        this.weeklies
      );
    }
  },
  methods: {
    async open() {
      await this.$root.$modal.show(ManageGroupMissionTaskModal, {
        selectedTypeFilter: this.getSelectedFilterType(),
        missionId: this.mission.id
      });
    },
    getSelectedFilterType() {
      return Object.keys(this.filters).find(k => this.filters[k]);
    },
    onTasksFilterChange(type) {
      this.$store.dispatch(UPDATE_MISSION_TASKS_TYPES_FILTER, type);
    },
    async showArchivedTasks() {
      this.toggleArchivedTasks = true;
      this.$vuetify.goTo(ARCHIVED_TASKS_SELECTOR, { easing: 'easeOutQuint' });
    },
    closeArchivedTasks() {
      this.toggleArchivedTasks = false;
    }
  }
};
</script>
